import { WinnerRole } from './shared/winner-role-types';
import { AwardType } from '../common/types/award-types';

export const validDocumentGroupTypeKeys = ['award-resource', 'winner-resource', 'judging-resource'] as const;

export type DocumentGroupTypeCode = typeof validDocumentGroupTypeKeys[number];

export const DocumentGroupTypeCodes: Record<DocumentGroupTypeCode, string> = {
  'award-resource': 'Award Resource',
  'winner-resource': 'Winner Resource',
  'judging-resource': 'Judging Resource'
};

export interface ProgramDocument {
  programDocumentId: number;
  displayName: string;
  fileLocationUrl: string;
  description: string;
  documentGroupTypeCode: DocumentGroupTypeCode;
  documentGroupDisplayName: string;
  winnerRole?: WinnerRole;
  awardType?: AwardType;
  ordinal: number;
}
